import React from 'react'
import styles from './Advantage.module.css'

export default function Advantage() {
    return (
        <div className={styles.container}>
            <div className={styles.layout}>
                <div className={styles.wrapper}>
                    <h1 className="title">
                        <span className="underline">
                        Давуу талууд
                        </span>
                    </h1>
                    <div className={styles.grid_layout}>
                        <div className={styles.child}>
                            <img src="/professional.svg" alt="professional"/>
                            <h1>Мэргэжлийн</h1>
                        </div>
                        <div className={styles.child}>
                            <img src="./qualified.svg" alt="qualified"/>
                            <h1>Мэргэшсэн</h1>
                        </div>
                        <div className={styles.child}>
                            <img src="./experience.svg" alt="experience"/>
                            <h1>Туршлагатай</h1>
                        </div>
                        <div className={styles.child}>
                            <img src="./quality.svg" alt="quality"/>
                            <h1>Чанартай</h1>
                        </div>
                        <div className={styles.child}>
                            <img src="./fast.svg" alt="fast"/>
                            <h1>Түргэн шуурхай</h1>
                        </div>
                        <div className={styles.child}>
                            <img src="./money.svg" alt="money"/>
                            <h1>Боломжийн үнэ ханш</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
